export default "__VITE_ASSET__W4dR7i4G__"